import { render } from "./HeroiconsSolidCode.vue?vue&type=template&id=6b507c67"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCode.vue"]])

export default __exports__